<template>
    <div class="page pageNews">
        <panel
            ref="panel"
            :wapTitle="'拍卖速递'"
            :appLink="appLink"
            :spreadID="0"
            :showNav="true"
            isShowNav="true"
            showLogin="true"
            @gotoApp="gotoApp"
        ></panel>
        <div class="newsList">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
            >
                <div v-if="newsData.length > 0">
                    <template v-for="(item,i) in newsData">
                        <a :href="item.link" :key="i">
                            <dl class="feed1 fix" v-if="item.show_type == 2 && item.pic.length < 3">
                                <dt>
                                    <img :src="item.pic[0]" alt="">
                                </dt>
                                <dd>
                                    <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>
                                    <p>
                                        <span class="source">{{item.resource}}</span><span class="newsTime"><i>{{item.published_text}}</i><i v-if="item.view_num > 0">{{item.view_num}}浏览</i></span>
                                    </p>
                                </dd>
                            </dl>
                            <dl class="feed2 fix" v-else-if="item.show_type == 2 && item.pic.length > 2">
                                <a :href="item.link">
                                <dt>
                                    <ul class="picList fix">
                                        <template v-for="(picItem,i) in item.pic">
                                            <li :key="i">
                                                <img :src="picItem" alt="">
                                            </li>
                                        </template>
                                    </ul>
                                </dt>
                                <dd>
                                    <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>
                                    <p>
                                        <span class="source">{{item.resource}}</span><span class="newsTime"><i>{{item.published_text}}</i><i v-if="item.view_num > 0">{{item.view_num}}浏览</i></span>
                                    </p>
                                </dd>
                                </a>
                            </dl>
                            <dl class="feed2 fix" :key="i" v-else-if="item.show_type == 3">
                                <a :href="item.link">
                                <dt>
                                    <ul class="picList fix">
                                        <template v-for="(picItem,i) in item.pic">
                                            <li :key="i">
                                                <img :src="picItem" alt="">
                                            </li>
                                        </template>
                                    </ul>
                                </dt>
                                <dd>
                                    <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>
                                    <p>
                                        <span class="source">{{item.resource}}</span><span class="newsTime"><i>{{item.published_text}}</i><i v-if="item.view_num > 0">{{item.view_num}}浏览</i></span>
                                    </p>
                                </dd>
                                </a>
                            </dl>
                            <dl class="feed3 fix" :key="i" v-else-if="item.show_type == 4">
                                <a :href="item.link">
                                <dt>
                                    <div class="listVideo">
                                        <img :src="item.pic[0]" alt="">
                                        <span class="icoVideo"></span>
                                    </div>
                                </dt>
                                <dd>
                                    <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>
                                    <p>
                                        <span class="source">{{item.resource}}</span><span class="newsTime"><i>{{item.published_text}}</i><i v-if="item.view_num > 0">{{item.view_num}}浏览</i></span>
                                    </p>
                                </dd>
                                </a>
                            </dl>
                            <dl class="feed4 fix" :key="i" v-else-if="item.show_type == 1">
                                <a :href="item.link">
                                <dd>
                                    <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>
                                    <p>
                                        <span class="source">{{item.resource}}</span><span class="newsTime"><i>{{item.published_text}}</i><i v-if="item.view_num > 0">{{item.view_num}}浏览</i></span>
                                    </p>
                                </dd>
                                </a>
                            </dl>
                            <dl class="feed3 fix" :key="i" v-else-if="item.show_type == 5 || item.show_type == 7">
                                <a :href="item.resource_type == '7' ? 'https://m-auction.artron.net/live/detail?id='+item.resource_id+'&special_id='+item.specail_id : item.link">
                                <dt>
                                    <div class="listVideo">
                                        <img :src="item.pic[0]" alt="">
                                        <span class="icoVideo"></span>
                                        <span v-if="item.tag_text" class="flag">{{item.tag_text}}</span>
                                    </div>
                                </dt>
                                <dd>
                                    <h3 class="newsTit"><span class="title">{{item.title}}</span></h3>
                                    <p>
                                        <span class="source">{{item.resource}}</span><span class="newsTime"><i>{{item.published_text}}</i><i v-if="item.view_num > 0">{{item.view_num}}浏览</i></span>
                                    </p>
                                </dd>
                                </a>
                            </dl>
                        </a>
                    </template>
                </div>
                <emptyPage v-else></emptyPage>
            </van-list>
            <div class="noMore" v-if="noMore">
                <span>我是有底线的</span>
            </div>
        </div>
        <DownLoadApp ref="downloadPop"></DownLoadApp>
        <watermark v-if="showWater"></watermark>
    </div>
</template>

<script>
import emptyPage from "@/components/empty/emptyPage"
import {newslist} from "@/api/new";
import {
    mapActions,mapGetters
} from 'vuex';
import panel from "@/views/preview/component/panel";
import DownLoadApp from "@/components/common/downloadApp";
import watermark from "@/components/common/watermark";
import {getWXConfig} from "@/assets/js/weixinShare";
export default {
    name: "news",
    data(){
        return{
            showWater:false,
            picList: [
                "https://img0.baidu.com/it/u=316865976,2940650346&fm=26&fmt=auto&gp=0.jpg",
                "https://img1.baidu.com/it/u=2496571732,442429806&fm=26&fmt=auto&gp=0.jpg",
                "https://img0.baidu.com/it/u=3870964477,3746012709&fm=26&fmt=auto&gp=0.jpg",
                "https://img2.baidu.com/it/u=3801054094,4185100754&fm=11&fmt=auto&gp=0.jpg",
                "https://img0.baidu.com/it/u=2604085216,1485343016&fm=26&fmt=auto&gp=0.jpg",
                "https://img0.baidu.com/it/u=1765955304,1858984308&fm=26&fmt=auto&gp=0.jpg",
            ],
            appLinkShow:true,
            active:0,
            page:1,
            newsData:[],
            loading: false,
            finished: false,
            noMore:false,
            appLink: "/2/8/0",
        }
    },
    created() {
        if(this.$route.query.from && this.$route.query.from == 'cloud'){
            this.showWater = true
        }
    },
    mounted() {
        if (!this.getIsLoadIng){
            this.getPageNews([ 0,null,()=>{
                this.filteData();
            }])
        }else{
            // console.log("服务端调用",this.param);
            this.filteData();
        }
        // this.getData()
    },
    asyncData({ store }) {
        let params = {type:0,page:1,only_meta:1}
        return store.dispatch("pageNews/getPageNews", [params,null, () => {}]);
    },
    computed:{
        ...mapGetters({
            getIsLoadIng: "pageNews/getIsLoadIng",
            getData: "pageNews/getData",
        }),
    },
    methods: {
        ...mapActions({
            getPageNews:"pageNews/getPageNews"
        }),
        gotoApp(){
            this.$refs.downloadPop.gotoAppDownload(this.appLink,0)
        },
        filteData(){
            let dome = this.$store.state["pageNews"]["data"];
            document.title = dome.meta ? dome.meta.title : "";
            let head = document.getElementsByTagName("head");
            if (!document.querySelector("meta[name=description]")) {
                let meta = document.createElement("meta");
                meta.name = "description";
                meta.content = dome.meta ? dome.meta.description : "";
                head[0].appendChild(meta);
            } else {
                document
                    .querySelector("meta[name=description]")
                    .setAttribute(
                        "content",
                        dome.meta ? dome.meta.description : ""
                    );
            }
            window.AFedWxShareData = {
                title: dome.meta ? dome.meta.shareTitle : "",
                imgUrl:
                    dome.meta.pic ||
                    "https://pubunder.artron.net/pubimgs/m/wxImgAuc.png",
                desc: dome.meta.description || "",
                link: window.location.href,
            };
            getWXConfig(window.AFedWxShareData);
        },
        onLoad(){
            this.getNewsData();
        },
        getNewsData(){
            let params = {
                type:0,
                page:this.page,
                pagesize:20
            }
            // this.loading = true;
            newslist(params).then((res) => {
                if (res.code == 0) {
                    if (res.data.morePage == 0) {
                        this.loading = false;
                        this.finished = true;
                    }else if (res.data.newsList.length) {
                        this.newsData = this.newsData.concat(res.data.newsList);
                        this.loading = false;
                        this.page++;
                        if (res.data.morePage == 0) {
                            this.finished = true;
                            this.noMore = true;
                        }
                    }
                }
            });
        },
    },
    components:{
        emptyPage,
        panel,
        DownLoadApp,
        watermark
    }
}
</script>

<style scoped lang="scss">
.newsList{padding:.5rem;
    a{display:block;margin-bottom: .5rem;}
    a:last-child{margin-bottom: 0;}
    dl{background-color: #fff;border-radius: .5rem;margin-bottom: .5rem;padding:.5rem;display:flex;}
    dl:last-child{margin-bottom: 0;}
    dd{height:3.75rem;position: relative;display:flex;flex-direction: column;justify-content:space-between;}
    .newsTit{line-height: 1.1rem;font-size: .8rem;color:#27282d;overflow: hidden;max-height: 2.2rem;display:-webkit-box;text-overflow:ellipsis;-webkit-line-clamp:2;-webkit-box-orient:vertical;flex-direction: column;
        .flag{width:2.5rem;height:.8rem;margin-right: .15rem;font-size: 0;vertical-align: .3rem;
            img{width:2.5rem;height:.8rem;object-fit: cover;}
        }
        .title{text-align: justify;}
    }
    p{line-height: 1rem;display:flex;justify-content: space-between;font-size: .5rem;}
    .source{color:#666;
        img{width:1rem;height:1rem;border-radius: 50%;object-fit: cover;margin-right: .5rem;float:left;}
    };
    .newsTime{color:#969696;
        i:first-child{margin-left: 0;}
        i{margin-left: .5rem;}
    }
    .feed1{
        dt{width:5.4rem;height:3.75rem;margin-right: .5rem;
            img{width:100%;height:100%;object-fit: cover;border-radius: .25rem;overflow: hidden;}
        }
        dt+dd{width:11rem;}
        p{
            .source{max-width: 4.5rem;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
        }
    }
    .feed2{flex-direction: column;
        .picList{margin-bottom: .5rem;
            li{width:5.4rem;height:3.75rem;border-radius: .25rem;overflow: hidden;float: left;margin-right: .25rem;
                img{width:100%;height:100%;object-fit: cover;overflow: hidden}
            }
            li:last-child{margin-right: 0;}
        }
    }
    .feed3{flex-direction: column;
        .listVideo{height:9.4rem;overflow: hidden;border-radius: .25rem;position: relative;margin-bottom: .5rem;
            img{width:100%;height:100%;object-fit: cover;}
            .icoVideo{width:1.7rem;height:1.7rem;position: absolute;left:50%;top:50%;transform: translate(-50%,-50%);background: url("../../assets/img/icon_btn_play@2x.png") no-repeat;background-size: cover;}
            .flag{position: absolute;right:0;top:.5rem;height:.8rem;
                 background: #18BD6F;
                 padding: 0 0.5rem;
           color: #fff;
           text-align: center;
           font-size: 0.5rem;
           line-height:.9rem;
            border-top-left-radius: 1rem;
             border-bottom-left-radius: 1rem;
            }
        }
    }
    .feed4{
        dd{width:100%;}
        p{justify-content: space-between;}
    }

}
</style>